import { Component, OnInit } from '@angular/core';
import { PuiUserProfileService, getThemeById } from '../../../core';

@Component({
    selector: 'pui-user-profile',
    templateUrl: 'user-profile.component.html',
    styleUrls: ['user-profile.component.scss']
})
export class PuiUserProfileComponent implements OnInit {
    currentThemeId: string;

    constructor(public userProfileService: PuiUserProfileService) { }

    ngOnInit() {
        this.currentThemeId = this.userProfileService.getTheme().id;
     }

    setTheme(newThemeId: string) {
        this.currentThemeId = newThemeId;
        const selectedTheme = getThemeById(this.currentThemeId);
        if (selectedTheme !== null) {
          this.userProfileService.setTheme(selectedTheme);
        }
    }
}
